import React, { useState, useEffect } from 'react';
import closeIcon from '../images/close-line.svg';
import infoIcon from '../images/question-line.svg';
import bookCover from '../images/empty-book.svg';
import TextInput from './TextInput';
import { useTranslation } from '../i18n';
import './BookDetails.css';
import { updateProtocol } from '../utils/functions';

const AddMissingBookInfo = ({ currentBook, open, onClose, onSave }) => {
  const { t } = useTranslation();
  const [title, setTitle] = useState('');
  const [author, setAuthor] = useState('');
  const [pages, setPages] = useState('');
  const [disabled, setDisabled] = useState(true);

  useEffect(() => {
    // Check if all required fields are filled
    const shouldEnableSaveButton =
      (currentBook.title !== 0 || title.trim() !== '') &&
      (currentBook.author_name?.length > 0 || author.trim() !== '') &&
      (currentBook.number_of_pages > 0 || pages > 0);

    setDisabled(!shouldEnableSaveButton);
  }, [title, author, pages, currentBook]);

  const handleSave = () => {
    onSave({ title, author, pages });
    onClose();
  };

  return (
    <dialog open={open} onClose={onClose}>
      <div className="fullscreen-container" tabIndex={-1}>
        <button className="fullscreen-close" onClick={onClose}>
          <img src={closeIcon} width={42} height={42} alt={t.close} />
          {t.close}
        </button>

        <div className="image-wrapper">
          <img
            src={updateProtocol(currentBook?.cover_url[0]) || bookCover}
            alt={currentBook?.title || t.missingcover}
            height={200}
            width={140}
            className="card-edit-image"
          />
        </div>

        <div className="addinfo-message fs-l">
          <img src={infoIcon} width={32} height={32} alt={t.close} />
          {t.addmissinginfoMessage}
        </div>

        {currentBook.title === '' && (
          <TextInput
            labelName={t.titleLabel}
            id="title"
            onChangeFunction={(e) => setTitle(e.target.value)}
            value={title}
            required={true}
          />
        )}
        {currentBook.author_name?.length === 0 && (
          <TextInput
            labelName={t.authorLabel}
            id="author"
            onChangeFunction={(e) => setAuthor(e.target.value)}
            value={author}
            required={true}
          />
        )}
        {(currentBook.number_of_pages === 0 ||
          isNaN(currentBook.number_of_pages)) && (
          <TextInput
            type="number"
            labelName={t.pages}
            id="pages"
            onChangeFunction={(e) => setPages(e.target.value)}
            value={pages}
            required={true}
            inputmode="numeric"
          />
        )}

        <div className="btn-group-wrapper">
          <div className="btn-group btn-group-two-col">
            <button className="btn btn-secondary w-100" onClick={onClose}>
              {t.cancel}
            </button>
            <button
              disabled={disabled}
              className="btn btn-primary w-100"
              onClick={handleSave}
            >
              {t.updatebook}
            </button>
          </div>
        </div>
      </div>
    </dialog>
  );
};

export default AddMissingBookInfo;
